import { CaretRightIcon } from '@radix-ui/react-icons';
import { Flex, Link, Skeleton, Text } from '@radix-ui/themes';
import { t } from 'i18next';
import { IBreadcrumb } from 'interfaces/i-breadcrumbs';
import { RADIX } from 'lib_ts/enums/radix-ui';
import React from 'react';

export const Breadcrumbs = (props: {
  items: IBreadcrumb[];
  loading?: boolean;
}) => {
  return (
    <Flex gap="1">
      {props.items.map((b, i) => (
        <React.Fragment key={`breadcrumb-${i}`}>
          {i > 0 && !props.loading && (
            <Text size="4">
              <CaretRightIcon />
            </Text>
          )}

          {b.onClick ? (
            <Skeleton loading={!!props.loading}>
              <Link
                className="cursor-pointer"
                color={RADIX.COLOR.ACCENT}
                onClick={b.onClick}
              >
                {t(b.label)}
              </Link>
            </Skeleton>
          ) : (
            <Skeleton loading={!!props.loading}>
              <Text>{t(b.label)}</Text>
            </Skeleton>
          )}
        </React.Fragment>
      ))}
    </Flex>
  );
};
